import React from 'react';

export default class EditIntegration extends React.Component {
	render() {
		return null;
	}
}
